import { useCallback } from 'react'
import InputBase from '@mui/material/InputBase'
import Search from '@mui/icons-material/Search'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { Theme } from '@mui/material/styles'
import { Kbd } from '../Kbd'

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: (theme: Theme) => theme.spacing(1, 2),
    borderBottom: (theme: Theme) => `1px solid ${theme.palette.divider}`,
  },
  icon: {
    marginRight: (theme: Theme) => theme.spacing(1),
    opacity: 0.54,
  },
  input: {
    flex: 1,
    fontSize: '1rem',
  },
  hint: {
    opacity: 0.4,
    fontSize: '0.75rem',
    whiteSpace: 'nowrap',
    marginLeft: (theme: Theme) => theme.spacing(1),
  },
}

interface GlobalSearchInputProps {
  value: string
  onChange: (value: string) => void
  onKeyDown: (e: React.KeyboardEvent) => void
}

export const GlobalSearchInput = ({ value, onChange, onKeyDown }: GlobalSearchInputProps) => {
  const inputRef = useCallback((el: HTMLInputElement | null) => {
    if (el) setTimeout(() => el.focus(), 0)
  }, [])

  return (
    <Box sx={styles.wrapper}>
      <Search sx={styles.icon} />
      <InputBase
        sx={styles.input}
        placeholder="Search..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        inputRef={inputRef}
        fullWidth
      />
      <Typography sx={styles.hint}>
        <Kbd>Esc</Kbd> to close
      </Typography>
    </Box>
  )
}
